export default __webpack_public_path__ + "static/media/closedJob.af4d8867.svg";